import { useCallback } from "react";

var API_URL = process.env.REACT_APP_BACKEND_URL;

export function useApi(token) {
  var fetchApi = useCallback(async function(path, options) {
    var opts = options || {};
    var headers = Object.assign({}, opts.headers || {});
    if (token) headers.Authorization = "Bearer " + token;
    var response = await fetch(API_URL + path, {
      credentials: "include",
      headers: headers,
      method: opts.method || "GET",
      body: opts.body
    });
    return response;
  }, [token]);

  var fetchJson = useCallback(async function(path, options) {
    var response = await fetchApi(path, options);
    if (response.ok) return await response.json();
    throw new Error((await response.json().catch(function() { return {}; })).detail || "Request failed");
  }, [fetchApi]);

  var postJson = useCallback(async function(path, data) {
    return fetchApi(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }, [fetchApi]);

  var putJson = useCallback(async function(path, data) {
    return fetchApi(path, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }, [fetchApi]);

  return { fetchApi, fetchJson, postJson, putJson };
}

export var languages = [
  { code: "en", name: "English", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "fr", name: "Fran\u00e7ais", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "de", name: "Deutsch", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "nl", name: "Nederlands", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "es", name: "Espa\u00f1ol", flag: "\u{1F1EA}\u{1F1F8}" },
];

export var currencies = [
  { code: "EUR", name: "EUR (\u20ac)", symbol: "\u20ac" },
  { code: "USD", name: "USD ($)", symbol: "$" },
  { code: "GBP", name: "GBP (\u00a3)", symbol: "\u00a3" },
  { code: "CHF", name: "CHF", symbol: "CHF" },
  { code: "SEK", name: "SEK (kr)", symbol: "kr" },
  { code: "NOK", name: "NOK (kr)", symbol: "kr" },
  { code: "DKK", name: "DKK (kr)", symbol: "kr" },
  { code: "PLN", name: "PLN (z\u0142)", symbol: "z\u0142" },
  { code: "CZK", name: "CZK (K\u010d)", symbol: "K\u010d" },
];
